import { STAGING_DIVERSION_TARGETS } from "./SystemSettingsStagingDiversion.constants";
import type { StagingDiversion } from "./SystemSettingsStagingDiversion.types";

export const isBaseLocationValid = (value: string, scheme: string) =>
  !value.includes("://") || value.startsWith(scheme);

/** Same rule as the backend: a base location plus at least one target. */
export function isDiversionValid(diversion: StagingDiversion, scheme: string) {
  const base = diversion.base_location.trim();
  const targets = STAGING_DIVERSION_TARGETS.map((target) => diversion[target.key]);
  return (
    !!base &&
    isBaseLocationValid(base, scheme) &&
    targets.some((value) => value !== null) &&
    targets.every((value) => value === null || !!value.trim())
  );
}
